var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 1.66538C14.6667 1.15284 14.3729 0.68567 13.9109 0.46364C13.449 0.24161 12.9006 0.30404 12.5004 0.62422L6.199 5.6654H1.33333C0.59695 5.6654 0 6.2623 0 6.9987V14.9987C0 15.7351 0.59695 16.332 1.33333 16.332H6.199L12.5004 21.3732C12.9006 21.6934 13.449 21.7558 13.9109 21.5338C14.3729 21.3118 14.6667 20.8446 14.6667 20.332V1.66538ZM7.4996 8.0399L12 4.43954V17.5579L7.4996 13.9576C7.2632 13.7684 6.9694 13.6654 6.6667 13.6654H2.66667V8.332H6.6667C6.9694 8.332 7.2632 8.229 7.4996 8.0399ZM20.3297 5.336C19.809 4.81521 18.9648 4.81509 18.4441 5.3357C17.9233 5.8563 17.9231 6.7005 18.4438 7.2213C19.4436 8.2215 20.0053 9.5778 20.0053 10.992C20.0053 12.4062 19.4436 13.7625 18.4438 14.7627C17.9231 15.2834 17.9233 16.1277 18.4441 16.6483C18.9648 17.1689 19.809 17.1688 20.3297 16.648C21.8294 15.1478 22.672 13.1133 22.672 10.992C22.672 8.8707 21.8294 6.8362 20.3297 5.336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseSound);
export default __webpack_public_path__ + "static/media/decrease-sound.7759a104e9679d4ad2c7e905da6c2240.svg";
export { ForwardRef as ReactComponent };